










import {
    Vue,
    Component
} from "@/shared/vuepack";
import { useCardProviderOptionsStore } from "@/employee/store/cardProviderOptions";
import { CardProvider } from "@/shared/types";
import WexDebitCards from "@/employee/components/settings/WexDebitCardUi.vue";
import FiservDebitCards from "@/employee/components/settings/hsaBank/FiservDebitCards.vue";

@Component({
    components: {
        FiservDebitCards,
        WexDebitCards
    }
})
export default class CardManagementContainer extends Vue {
    cardProviderOptionsStore = useCardProviderOptionsStore();

    cardprovider = CardProvider;

    mounted (): void {
        this.cardProviderOptionsStore.getCardProviderOptions();
    }
}
